const getStepData = (number, steps) => steps.find((st) => st.number === number)?.payload || {}

export { getStepData }
